import React, { CSSProperties } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import Item from './Item';

type ItemProps = {
  id: any;
  style?: CSSProperties;
  disabled?: boolean;
};

const SortableItem: React.FC<ItemProps> = (props) => {
  const { style: outerStyle, disabled = false } = props;
  const { isDragging, attributes, listeners, setNodeRef, transform, transition } = useSortable({
    id: props.id,
    disabled,
  });

  const style = {
    ...outerStyle,
    transform: CSS.Transform.toString(transform),
    transition: transition || undefined,
    // backgroundColor: isDragging ? 'rgba(0,130,252)' : '#ffffff',
  };

  return (
    <Item
      disabled={disabled}
      ref={setNodeRef}
      style={style}
      withOpacity={isDragging}
      {...props}
      {...attributes}
      {...listeners}
    />
  );
};

export default SortableItem;
